<div class="fixed-menu" ng-if="$ctrl.fixedVisible() && $ctrl.fixedItems.length > 0">
    <ul>
        <li ng-repeat="item in $ctrl.fixedItems" ng-click="$ctrl.clickHandler($event, item)" ng-class="$ctrl.classes(item)">
            <span ng-bind-html="item.text"></span>
            <ul ng-if="item.subItems" class="c-main-color activity-list-menu active">
                <c-top-menu-item item="subItem" ng-repeat="subItem in item.subItems"></c-top-menu-item>
            </ul>
        </li>
    </ul>
</div>
<ul ng-if="$ctrl.extrasVisible() && $ctrl.extraItems.length > 0">
    <li ng-repeat="item in $ctrl.extraItems" ng-click="$ctrl.clickHandler($event, item)">
        <span ng-bind-html="item.text"></span>
    </li>
</ul>
<ul ng-if="$ctrl.menusVisible() && $ctrl.menuItems.length > 0">
    <li ng-repeat="item in $ctrl.menuItems" ng-click="$ctrl.clickHandler($event, item)" ng-class="$ctrl.classes(item)">
        <span ng-bind-html="item.text"></span>
        <ul ng-if="item.subItems" class="c-main-color activity-list-menu active">
            <c-top-menu-item item="subItem" ng-repeat="subItem in item.subItems"></c-top-menu-item>
        </ul>
    </li>
</ul>